import { Delete } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  useTheme
} from "@mui/material";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import React, { forwardRef, memo, useEffect, useImperativeHandle, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { useStyle } from "../style";

const BillingTable = forwardRef((props, ref) => {
  const theme = useTheme();
  const outletId = localStorage.getItem('outlet_id')
  const classes = useStyle();
  const {data, setData,code, setCode, setPostData , poDetails} = props
  const [itemData, setItemData] = useState(null)
  const [qty, setQty] = useState('')
  const dispatch = useDispatch()
  const [reasonData, setReasonData] = useState("");
  const [rateData, setRateData] = useState({
    mrp : '',
    disc :'',
    rate :'',
    gst : '',
  })
  
  const [editingIndex, setEditingIndex] = useState(null);

  const codeRef = useRef(null)
  const qtyRef = useRef(null)
const reasonRef = useRef(null)
  const priceRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
  }

  const updatedRef = {
    mrp : useRef(null),
    gst : useRef(null),
    rate : useRef(null),
    disc : useRef(null),
    qty : useRef(null),
    reason:useRef(null)

  }
  const handleCodeKeyPress = (e) =>{
      if(e.key === "Enter" && code!==''){
          getItemCode(code)
      }
  }
console.log(code)
const handleReasonChange = (e) => {
  // const newData = [...data];
  // newData[idx].reason = e.target.value;
  // setData(newData);
  console.log(e.target.value)
  setReasonData(e.target.value)
};
  const handleAddRow=(e)=>{
      if(e.key==='Enter' && qty!==''){
          const objData = {
              code: code,
              qty: qty,
              mrp1: rateData.mrp,
              rate1: rateData.rate,
              gst1: rateData.gst,
              disc1: rateData.disc,
              gstAmt:parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(rateData.gst) / 100) * parseFloat(qty)).toFixed(2),
              cessAmt: parseFloat((parseFloat(rateData.rate) - parseFloat(rateData.rate) * parseFloat(rateData.disc) / 100) * (parseFloat(itemData.cess) / 100) * parseFloat(qty)).toFixed(2),
              totalAmt: parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(2),
              reason: reasonData,
              ...itemData
          }
          console.log(objData)
          const existingItemIndex = data.findIndex((item) => item.code === objData.code && (item.mrp1 === objData.mrp || item.mrp1 === objData.mrp1));
          const arr = [...data]       
          setData([])
          if (existingItemIndex !== -1) {
          // If the item exists, update its quantity, gst, cess, total
            arr[existingItemIndex].qty = parseFloat(arr[existingItemIndex].qty) + parseFloat(objData.qty);    
            arr[existingItemIndex].gstAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].gst1  / 100))* parseFloat(arr[existingItemIndex].qty);    
            arr[existingItemIndex].cessAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * (parseFloat(arr[existingItemIndex].cess / 100))* parseFloat(arr[existingItemIndex].qty);    
            arr[existingItemIndex].totalAmt = (parseFloat(arr[existingItemIndex].rate1)-parseFloat(arr[existingItemIndex].rate1) * parseFloat(arr[existingItemIndex].disc1 / 100)) * parseFloat(arr[existingItemIndex].qty);  
            arr[existingItemIndex].reason = objData.reason;
            setData(arr)
          } else {
          // If the item doesn't exist, add it to the 'data' array
            arr.push(objData)
            setData(arr)
          }
          setCode('')
          setQty('')
          setItemData(null)
          setReasonData(''); 
          setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
          codeRef.current.focus()
      }
  }
  const handleDeleteRow=(e, i)=>{
    const updateArr = [...data]
    updateArr.splice(i,1)
    setData(updateArr)
  }
  const handleQtyChange = (e) =>{
      setQty(e.target.value)
  }
  const handleCodeChange = (e) =>{
      // setCode(e.target.value)
      setCode(e.target.value.toUpperCase());

  }
  
const handleKeyPress = (e) =>{
if(e.key==='Enter' && e.target.value!=='' ){
  const nextRef = e.target.name
checkRef(nextRef)

}
else if(e.key==='Enter' && e.target.name == 'disc'){
  const nextRef = e.target.name
  checkRef(nextRef)
}
}
function checkRef(value){
  if(value=='mrp'){
    priceRef.gst.current.focus()
  }
  else if(value == 'gst'){
    priceRef.rate.current.focus()
  }
  else if(value == 'rate'){
    priceRef.disc.current.focus()
  }
  else if(value == 'disc'){
    if(rateData.disc===''){
      setRateData(prev=> ({...prev, disc : '0'}))
      qtyRef.current.focus()
    }
  }
  else if(value == 'qty'){
    reasonRef.current.focus()
  }
}
const handleRateChange = (e) =>{
  setRateData((prevData) => ({...prevData, [e.target.name] : e.target.value}))
}
  const getItemCode = (id) =>{
    // axios.get(`/v1/ItemCode/${id}`)
    axios.get(`/v1/itemdetails/barcode/${id}/${outletId}`)
    .then(res=>{
      setItemData(res.data)
      setRateData((prevData) => ({ ...prevData, mrp: res.data.mrp, rate: res.data.pur_rate, gst : res.data.gst }));
      reasonRef.current.focus()
      setQty('1')
    })
    .catch(err=>{
      console.log(err.response.data.errors[0].message)
      dispatch(setSnackbar(true , "error" ,err.response.data.errors[0].message ))
    })
  }
  const clearNew = () =>{
    setCode('')
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
  const handleEditChange = (e, name) => {
    const arr=[...data]
    const value = e.target.value.replace(/\D/g, '')
    setData([])
    if(name==='gst'){
      arr[editingIndex].gst1 = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (value / 100) * arr[editingIndex].qty).toFixed(2)
      setData(arr)
    }
    else if(name==='mrp'){
      arr[editingIndex].mrp1 = value
      setData(arr)
    }
    else if(name==='rate'){
      arr[editingIndex].rate1 = value
     arr[editingIndex].gstAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(2)
     arr[editingIndex].totalAmt = parseFloat((value - value * arr[editingIndex].disc1 / 100)  * arr[editingIndex].qty).toFixed(2)
     arr[editingIndex].cessAmt= parseFloat((value - value * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(2)
      setData(arr)
    }
    else if(name==='disc'){
      let discValue = value==='' ? 0 :  value
      arr[editingIndex].disc1 = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(discValue) / 100) * (arr[editingIndex].gst1 / 100) * arr[editingIndex].qty).toFixed(2)
     arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 *  parseFloat(discValue) / 100)  * arr[editingIndex].qty).toFixed(2)
     arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * parseFloat(discValue) / 100) * (arr[editingIndex].cess / 100) * arr[editingIndex].qty).toFixed(2)
      setData(arr)
    }
    else if(name==='qty'){
      arr[editingIndex].qty = value
     arr[editingIndex].gstAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].gst1 / 100) * value).toFixed(2)
     arr[editingIndex].totalAmt = parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100)  * value).toFixed(2)
     arr[editingIndex].cessAmt= parseFloat((arr[editingIndex].rate1 - arr[editingIndex].rate1 * arr[editingIndex].disc1 / 100) * (arr[editingIndex].cess / 100) * value).toFixed(2)
      setData(arr)
    }
    
  };
 function getSelectedRow(e){
  setEditingIndex(e)
 } 

 function handleUpdatedKey(e){
    if(e.key==='Enter' && e.target.value!=='' ){
      const nextRef = e.target.name
      checkUpdatedRef(nextRef)
    }
    else if(e.key==='Enter' && e.target.name==='disc'){
      const nextRef = e.target.name
      checkUpdatedRef(nextRef)
    }
 }
 function checkUpdatedRef(value){
if(value==='mrp'){
updatedRef.gst.current.focus()
}
else if(value==='gst'){  
updatedRef.rate.current.focus()
}
else if(value==='rate'){  
  updatedRef.disc.current.focus()
  }
  else if(value==='disc'){  
    const arr = [...data];
    setData([])
    if(arr[editingIndex].disc1===''){
      arr[editingIndex].disc1 = 0
      arr[editingIndex].gstAmt = parseFloat(arr[editingIndex].rate1 )
       arr[editingIndex].totalAmt = parseFloat(arr[editingIndex].rate1 )
       arr[editingIndex].cessAmt= parseFloat(arr[editingIndex].rate1 )
    }
    setData(arr)

    updatedRef.qty.current.focus()
    }
  else if(value==='qty'){
addToData()
  }
 }

 function addToData(){
codeRef.current.focus()
 }
 useImperativeHandle(ref, () => ({
  focusCodeInput: () => {
    setQty('')
    setItemData(null)
    setRateData((prevData) => ({ ...prevData, mrp: "", rate: "", gst : "", disc : "" }))
    codeRef.current.focus()
  }
}));
useEffect(() => {
if(data.length > 0){
  let arr=[]
  data.map(val=>{
    const obj = {
      date:moment(poDetails.docDate).format('YYYY-MM-DD'),
      // docdate:moment().format('YYYY/MM/DD'),
      prodid:val.id,
      // dis_per:val.disc1,
      // dis_amt:parseFloat((val.rate1 -(val.rate1 * (100 - val.disc1 )/ 100)) * val.qty).toFixed(2),
      // mrp:val.mrp1,
      rate:val.mrp1,
      qty:val.qty,
      amount:val.rate1,
      reason:val.reason,
      company_id:22
      // gst_per:val.gst1,
      // gst_amt: parseFloat(val.gstAmt).toFixed(2),
      // cess_per:val.cess,
      // cess_amt:val.cessAmt,
      // barcode:  val.barcode,
      // head_id: val.head_id ,
      // type_id:  val.type ,
      // subcat_id:  val.sub_cat ,
      // cat_id:  val.cat_id ,
      // uom_id:  val.uom ,
    }
    arr.push(obj)
  })
  setPostData((prevState)=>({...prevState, wastage_detail: arr , }))
}
  
},[data,poDetails])
console.log(data)
return (
    <Grid className="w-full h-full">
      <TableContainer className={classes.tblRoot}>
        <Table stickyHeader  className={classes.table}>
          <TableHead className={classes.tblHeader} sx={{position: "sticky",top: 0,}}>
            <TableRow className={classes.tablrow}>
              <TableCell className={classes.tblCell} sx={{borderLeft:'0.5px solid  #ccc'}}>Sno</TableCell>
              <TableCell className={classes.tblCell}>Barcode</TableCell>
              <TableCell className={classes.tblCell}>Description</TableCell>
              <TableCell className={classes.tblCell}>MRP</TableCell>
              <TableCell className={classes.tblCell}>GST%</TableCell>
              <TableCell className={classes.tblCell}>Rate</TableCell>
              <TableCell className={classes.tblCell}>Dis%</TableCell>
              <TableCell className={classes.tblCell}>Qty</TableCell>
              <TableCell className={classes.tblCell}>GST</TableCell>
              {/* <TableCell className={classes.tblCell}>CESS</TableCell> */}
              <TableCell className={classes.tblCell}>Amount</TableCell>
              <TableCell className={classes.tblCell}>Reason</TableCell>
              <TableCell className={classes.tblCell}>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {_.map(data, (val, idx) => (
               <TableRow className={classes.tablrow} key={idx} onClick={() => getSelectedRow(idx)}>
               <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{idx + 1}</TableCell>
                     <TableCell sx={{minWidth:"140px"}}>{val.code}</TableCell>
               <TableCell variant="body" className={classes.tblContentCell}>{val.pro_name}</TableCell>
               <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}} >{val.mrp1} </TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{val.gst1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>{ val.rate1}</TableCell>
               <TableCell padding="checkbox"  className={classes.tblContentCell} sx={{width:100}}>
               {/* <TextField
                      size="small"
                      inputRef={editingIndex===idx ? updatedRef.disc : null}
                      name="disc"
                      value={val.disc1 }
                      onChange={(e) => handleEditChange(e, "disc")}
                      onKeyPress={handleUpdatedKey}
                      InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none",textAlign:"center"}}} 
                    /> */}
                     {val.discount}
               </TableCell>
              
               <TableCell>1</TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.gst / 2).toFixed(2)}</TableCell>
               {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{parseFloat(val.cess).toFixed(2)}</TableCell> */}
               <TableCell className={classes.tblContentCell} sx={{width:100}}>{val.totalAmt}</TableCell>
               <TableCell>
    <TextField
      size="small"
      value={val.reason} // Update this line
      // onChange={(e) => handleReasonChange(e, idx)}
    />
  </TableCell>
               <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={()=>handleDeleteRow(val, idx)}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
             </TableRow>
            ))}
            <TableRow className={classes.tablrow}>
              <TableCell  padding="checkbox" className={classes.tblContentCell} sx={{borderLeft:'0.5px solid  #ccc'}}>{data.length + 1}</TableCell>
              <TableCell sx={{minWidth:"140px"}} padding="checkbox" className={classes.tblContentCell}>
              <TextField 
                inputRef={codeRef}
                size='small'
                value={code}
                onChange={handleCodeChange}
                onKeyPress={handleCodeKeyPress}
               />
                                  
              </TableCell>
              <TableCell variant="body" className={classes.tblContentCell}>{itemData!==null && itemData.pro_name }</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.mrp}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.gst}</TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>{rateData.rate} </TableCell>
              <TableCell padding="checkbox" className={classes.tblContentCell} sx={{width:100}}>
                 {itemData!==null && itemData.discount }
              </TableCell>
              <TableCell padding="checkbox" sx={{ width: 120 }}  className={classes.tblContentCell}>{qty}</TableCell>
              <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * (rateData.gst / 100) * qty).toFixed(2) }</TableCell>
              {/* <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * (itemData.cess / 100) * qty).toFixed(2) }</TableCell> */}
              <TableCell className={classes.tblContentCell} sx={{width:100}}>{itemData!==null && qty!=="" && parseFloat((rateData.rate - rateData.rate * rateData.disc / 100) * qty).toFixed(2) }</TableCell>
              <TableCell>
                <TextField
                  inputRef={reasonRef}
                  size="small"
                  value={reasonData}
                  onChange={handleReasonChange}
                  InputProps={{style:{outline: 'none', border: 'none',boxShadow:"none"}}}
                  onKeyPress={handleAddRow}
                  className={classes.tableInput}
                />
              </TableCell>
              <TableCell className={classes.tblContentCell} sx={{width:100}}><IconButton onClick={clearNew}><Delete sx={{color:'red', fontSize:18}}/></IconButton></TableCell>
            </TableRow>

          </TableBody>
        </Table>
      </TableContainer>
     
    </Grid>
  );
});

export default memo(BillingTable);
